import { MainProgressBarEnum } from "../../app/enums/mainProgressBarEnum";
import { routes } from "../../app/routes/routes";

export const mapStepToRoute = (step: MainProgressBarEnum) => {
    let route = routes.ordering.route;
    switch (step) {
        case MainProgressBarEnum.Search:
            route = routes.ordering.route;
            break;
        case MainProgressBarEnum.DeliveryOptions:
            route = routes.deliveryOptions.route;
            break;
        case MainProgressBarEnum.RecommendedServices:
            route = routes.recommendedServices.route;
            break;
        case MainProgressBarEnum.Booking:
            route = routes.booking.route;
            break;
        case MainProgressBarEnum.Verification:
            route = routes.verification.route;
            break;
        case MainProgressBarEnum.OrderConfirmation:
            route = routes.orderConfirmation.route;
            break;
        default:
            throw new Error("Step not found");
    }
    return route;
};

export const mapStepToPath = (step: MainProgressBarEnum) => {
    switch (step) {
        case MainProgressBarEnum.Search:
            return routes.ordering.path;
        case MainProgressBarEnum.DeliveryOptions:
            return routes.deliveryOptions.path;
        case MainProgressBarEnum.RecommendedServices:
            return routes.recommendedServices.path;
        case MainProgressBarEnum.Booking:
            return routes.booking.path;
        case MainProgressBarEnum.Verification:
            return routes.verification.path;
        case MainProgressBarEnum.OrderConfirmation:
            return routes.orderConfirmation.path;
        default:
            throw new Error("Step not found");
    }
};

export const mapRouteToStep = (pathName: string) => {
    const route = pathName.slice(1);
    switch (route) {
        case routes.ordering.route:
            return MainProgressBarEnum.Search;
        case routes.deliveryOptions.route:
            return MainProgressBarEnum.DeliveryOptions;
        case routes.recommendedServices.route:
            return MainProgressBarEnum.RecommendedServices;
        case routes.booking.route:
            return MainProgressBarEnum.Booking;
        case routes.verification.route:
            return MainProgressBarEnum.Verification;
        default:
            throw new Error("Route not found");
    }
};
